import React, { useState, useEffect } from 'react';
import { Icon, IconButton, Icons } from 'folds';
import cons from '../../../client/state/cons';
import navigation from '../../../client/state/navigation';
import { useMatrixClient } from '../../hooks/useMatrixClient';
import PopupWindow from '../../molecules/popup-window/PopupWindow';
import Text from '../../atoms/text/Text';
import { InviteRoleContent } from '../../features/room/InviteRoleContent';
import { InvitedSelectContent } from '../../features/room/InvitedSelectContent';

function InviteByRole() {
  const [roomId, setRoomId] = useState<string | null>(null);
  const mx = useMatrixClient();

  useEffect(() => {
    const open = (id: string) => setRoomId(id);
    navigation.on(cons.events.navigation.INVITE_BY_ROLE_OPENED, open);
    return () => {
      navigation.removeListener(cons.events.navigation.INVITE_BY_ROLE_OPENED, open);
    };
  }, []);

  const isOpen = roomId !== null;
  const room = roomId ? mx.getRoom(roomId) : null;
  const requestClose = () => setRoomId(null);

  return (
    <PopupWindow
      isOpen={isOpen}
      title={
        <Text variant="s1" weight="medium" primary>
          {room?.name ?? ''}
          <span style={{ color: 'var(--tc-surface-low)' }}> — 加入成員</span>
        </Text>
      }
      contentOptions={
        <IconButton variant="Background" onClick={requestClose}>
          <Icon src={Icons.Cross} />
        </IconButton>
      }
      onRequestClose={requestClose}
    >
      {isOpen && roomId && <InviteRoleContent roomId={roomId} />}
      {isOpen && roomId && <InvitedSelectContent roomId={roomId} />}

    </PopupWindow>
  );
}

export default InviteByRole;
